export default __webpack_public_path__ + "static/media/FlexiblePayment.22f4a3a8.svg";